import React from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card'
import { Badge } from '../components/ui/badge'

const Reports: React.FC = () => {
  return (
    <div className="container-mobile py-6 space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 flex items-center gap-2">
          📊 Reports
        </h1>
        <p className="text-gray-600 mt-1">
          View your performance reports and analytics
        </p>
      </div>

      {/* Coming Soon Content */}
      <Card className="max-w-4xl mx-auto">
        <CardHeader className="text-center">
          <div className="text-6xl mb-4">📊</div>
          <CardTitle className="text-2xl">Reports Coming Soon</CardTitle>
          <CardDescription className="text-lg">
            This feature is currently under development. You'll soon be able to view comprehensive analytics and insights.
          </CardDescription>
        </CardHeader>
        
        <CardContent>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Performance Analytics</h3>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <Badge variant="secondary" className="w-8 h-8 p-0 flex items-center justify-center">
                    ✅
                  </Badge>
                  <span className="text-gray-700">Daily work summaries</span>
                </div>
                <div className="flex items-center gap-3">
                  <Badge variant="secondary" className="w-8 h-8 p-0 flex items-center justify-center">
                    ✅
                  </Badge>
                  <span className="text-gray-700">Monthly performance metrics</span>
                </div>
                <div className="flex items-center gap-3">
                  <Badge variant="secondary" className="w-8 h-8 p-0 flex items-center justify-center">
                    ✅
                  </Badge>
                  <span className="text-gray-700">Completion rate statistics</span>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Client Insights</h3>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <Badge variant="secondary" className="w-8 h-8 p-0 flex items-center justify-center">
                    ✅
                  </Badge>
                  <span className="text-gray-700">Client satisfaction reports</span>
                </div>
                <div className="flex items-center gap-3">
                  <Badge variant="secondary" className="w-8 h-8 p-0 flex items-center justify-center">
                    ✅
                  </Badge>
                  <span className="text-gray-700">Time tracking analytics</span>
                </div>
                <div className="flex items-center gap-3">
                  <Badge variant="secondary" className="w-8 h-8 p-0 flex items-center justify-center">
                    ✅
                  </Badge>
                  <span className="text-gray-700">Service quality metrics</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="mt-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
            <h4 className="font-semibold text-blue-900 mb-2">Stay Tuned!</h4>
            <p className="text-blue-700 text-sm">
              We're working hard to bring you detailed insights about your work performance, 
              efficiency metrics, and client feedback. This will help you track your progress 
              and identify areas for improvement.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default Reports 